import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  Div, P, Loading, Input,
} from 'konsys-ui'
import {
  Select, Icon, Upload, Col, Checkbox,
} from 'antd'
import { PDRBankList, TRSBankList } from '../../invoice-page/constants'
import { BILL_INFO } from '../../../constants/graphql/query'
import { CREATE_BILL_PAYMENT } from '../../../constants/graphql/mutation'
import { PaymentActionBar, Wrapper } from '../../../components/bill-components'
import {
  MethodButton, DatePicker as DP, TaxSelect,
} from '../../../components/bill-components/styled'
import { theme } from '../../../styles/_variables'
import { checkFloat } from '../../../utils/util-services'

const taxList = [
  { value: 0, text: '0%' },
  { value: 0.5, text: '0.5%' },
  { value: 0.75, text: '0.75%' },
  { value: 1, text: '1%' },
  { value: 2, text: '2%' },
  { value: 3, text: '3%' },
  { value: 5, text: '5%' },
  { value: 10, text: '10%' },
  { value: 11.2, text: '11.2%' },
  { value: 13, text: '13%' },
  { value: 15, text: '15%' },
]

const { color } = theme

const Index = ({ props }) => {
  const [method, setMethod] = useState('CHEQUE')
  const [taxInput, setTaxInput] = useState(false)
  const [totalPaid, setTotalPaid] = useState('waitForLoading')
  const [mutationVariables, setMutationVariables] = useState({
    withHoldingTax: 0,
    amountWithHeld: 0,
    customerBankFees: 0,
    pdrBankFees: 0,
    lostWeightFee: 0,
    damagedGoodFee: 0,
    lostInsuranceFee: 0,
    discountFee: 0,
    lateTicketFee: 0,
    excessPaymentFee: 0,
    accidentFee: 0,
  })
  return (
    <Div display='flex' flexDirection='column'>
      {
        <Query
          query={BILL_INFO}
          variables={{
            id: props.match.params.id,
          }}
        >
          {
            ({
              data: bill, error: billError, loading: billLoading,
            }) => {
              if (billLoading && _.isEmpty(bill)) return <Loading />
              if (billError) return <P>เกิดข้อผิดพลาด</P>
              const info = bill.BillInfo
              if (totalPaid === 'waitForLoading') {
                setTotalPaid(info.grandTotal)
              }
              return (
                <Div>
                  <Mutation
                    mutation={CREATE_BILL_PAYMENT}
                    refetchQueries={['BillInfo']}
                  >{(doAction, { loading }) => (
                    <Div>
                      <Wrapper>
                        <Div display='flex' flexDirection='column' alignItems='flex-start' alignSelf='flex-start'>
                          <P>Ref ID</P>
                          <P bold margin='16px 0 0'>{info.refId}</P>
                        </Div>
                      </Wrapper>
                      <Wrapper>
                        <Div display='flex' flexDirection='row' margin='0 0 24px'>
                          <Div display='flex' flexDirection='row' justifyContent='space-around' margin='0 80px'>
                            <MethodButton
                              onClick={() => {
                                setMethod('CHEQUE')
                                if (mutationVariables.bankNumber) {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    chequeNumber: mutationVariables.bankNumber,
                                    bankNumber: '',
                                  })
                                }
                              }}
                              bg={method === 'CHEQUE'}
                            >เช็ค</MethodButton>
                          </Div>
                          <Div display='flex' flexDirection='row' justifyContent='space-around' margin='0 80px'>
                            <MethodButton
                              onClick={() => {
                                setMethod('TRANSFER')
                                if (mutationVariables.chequeNumber) {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    bankNumber: mutationVariables.chequeNumber,
                                    chequeNumber: '',
                                  })
                                }
                              }}
                              bg={method === 'TRANSFER'}
                            >โอนเงิน</MethodButton>
                          </Div>
                        </Div>
                        <Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* paidDate */}
                            <Col span={4}>
                              <P>วันที่รับชำระเงิน *</P>
                            </Col>
                            <Col span={6}>
                              <DP format='DD/MM/YYYY'
                                onChange={e => setMutationVariables({
                                  ...mutationVariables,
                                  paidDate: e,
                                })} />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* bank */}
                            <Col span={4}>
                              <P>ธนาคาร *</P>
                            </Col>
                            <Col span={6}>
                              <Select
                                dropdown
                                showSearch
                                style={{ width: 400 }}
                                onChange={e => setMutationVariables({
                                  ...mutationVariables,
                                  bank: e,
                                })}
                              >
                              {
                                info?.Job?.companyType === 'PADOONGRICH'
                                  ? PDRBankList.map(v => !_.isNull(v.text) && <Select.Option key={v.text} value={v.code}>{v.text}</Select.Option>)
                                  : TRSBankList.map(v => !_.isNull(v.text) && <Select.Option key={v.text} value={v.code}>{v.text}</Select.Option>)
                              }
                              </Select>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* bankNumber chequeNumber */}
                            <Col span={4}>
                              <P>เลขที่ *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={method === 'CHEQUE' ? mutationVariables.chequeNumber : mutationVariables.bankNumber}
                                onChange={(e) => {
                                  if (method === 'CHEQUE') {
                                    setMutationVariables({
                                      ...mutationVariables,
                                      chequeNumber: e.target.value,
                                    })
                                  } else {
                                    setMutationVariables({
                                      ...mutationVariables,
                                      bankNumber: e.target.value,
                                    })
                                  }
                                }}
                              />
                            </Col>
                          </Div>
                          {
                            method === 'CHEQUE'
                            && <Div display='flex' flexDirection='row' margin='0 0 16px'>
                              {/* chequeDate */}
                              <Col span={4}>
                                <P>วันที่หน้าเช็ค *</P>
                              </Col>
                              <Col span={6}>
                                <DP
                                  format='DD/MM/YYYY'
                                  value={mutationVariables.chequeDate}
                                  onChange={e => setMutationVariables({
                                    ...mutationVariables,
                                    chequeDate: e,
                                  })}
                                />
                              </Col>
                            </Div>
                          }
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* grandTotal */}
                            <Col span={4}>
                              <P>จำนวนเงิน *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={mutationVariables.amountReceived}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    amountReceived: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='16px 0 24px 215px'>
                            <MethodButton onClick={() => {
                              setMutationVariables({
                                ...mutationVariables,
                                withHoldingTax: taxInput ? undefined : parseFloat(0),
                                amountWithHeld: parseFloat(0),
                                // amountReceived: info.shippingGrandTotal - mutationVariables.bankFees,
                              })
                              setTaxInput(!taxInput)
                            }} bg={taxInput}>หัก ณ ที่จ่าย</MethodButton>
                          </Div>
                          {
                            taxInput
                            && <Div>
                              <Div display='flex' flexDirection='row' margin='0 0 16px'>
                                {/* withHoldingTax */}
                                <Col span={4}>
                                  <P>หัก ณ ที่จ่าย *</P>
                                </Col>
                                <Col span={6}>
                                  <TaxSelect
                                    dropdown
                                    value={mutationVariables.withHoldingTax}
                                    disabled={mutationVariables.isCustomWitholdingTax}
                                    defaultValue={_.isNull(mutationVariables.withHoldingTax) ? 'เลือกอัตราภาษี' : mutationVariables.withHoldingTax}
                                    onSelect={(e) => {
                                      setMutationVariables({
                                        ...mutationVariables,
                                        withHoldingTax: parseFloat(e),
                                        amountWithHeld: (parseFloat(e) / 100) * totalPaid,
                                        // amountReceived: info.shippingGrandTotal - ((parseFloat(e) / 100) * info.shippingGrandTotal) - (parseFloat(mutationVariables.bankFees)),
                                      })
                                    }}>
                                    {
                                      taxList.map(v => <TaxSelect.Option key={v.value} value={v.value}>{v.text}</TaxSelect.Option>)
                                    }
                                  </TaxSelect>
                                </Col>
                                <Col span={6}>
                                  <Div display='flex' alignItems='center'>
                                    <Checkbox
                                      style={{ padding: '3px 8px 0 16px' }}
                                      checked={mutationVariables.isCustomWitholdingTax}
                                      onChange={(e) => {
                                        setMutationVariables({
                                          ...mutationVariables,
                                          withHoldingTax: 0,
                                          amountWithHeld: 0,
                                          isCustomWitholdingTax: e.target.checked,
                                        })
                                      }}
                                    />
                                    <P>กำหนดยอดหัก ณ ที่จ่ายเอง</P>
                                  </Div>
                                </Col>
                              </Div>
                              {/* amountWithHeld */}
                              <Div display='flex' flexDirection='row' margin='0 0 16px'>
                                <Col span={4}>
                                  <P>ยอดเงินหัก ณ ที่จ่าย</P>
                                </Col>
                                <Col span={6}>
                                  <Input width='100%'
                                    disabled={!mutationVariables.isCustomWitholdingTax}
                                    value={mutationVariables.isCustomWitholdingTax ? mutationVariables.amountWithHeld : parseFloat(mutationVariables.amountWithHeld).toFixed(2)}
                                    onChange={(e) => {
                                      setMutationVariables({
                                        ...mutationVariables,
                                        amountWithHeld: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                      })
                                    }}
                                    onKeyDown={(e) => {
                                      if (!checkFloat(e)) {
                                        e.preventDefault()
                                      }
                                    }}
                                    type='number'
                                    step={0.1}
                                    min={0}
                                  />
                                </Col>
                              </Div>
                            </Div>
                          }
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* customerBankFees */}
                            <Col span={4}>
                              <P>ค่าธรรมเนียมที่ลูกค้าจ่าย *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={mutationVariables.customerBankFees}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    customerBankFees: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                    // amountReceived: _.isNaN(info.shippingGrandTotal - (_.isEmpty(e.target.value) ? 0 : parseFloat(e.target.value)) - (
                                    //   taxInput === true ? (parseFloat(mutationVariables.withHoldingTax) / 100) * info.shippingGrandTotal : 0))
                                    //   ? mutationVariables.amountReceived
                                    //   : info.shippingGrandTotal - (_.isEmpty(e.target.value) ? 0 : parseFloat(e.target.value)) - (
                                    //     taxInput === true ? (parseFloat(mutationVariables.withHoldingTax) / 100) * info.shippingGrandTotal : 0
                                    //   ),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* pdrBankFees */}
                            <Col span={4}>
                              <P>ค่าธรรมเนียมที่ผดุงฤทธิ์จ่าย *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={mutationVariables.pdrBankFees}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    pdrBankFees: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* lostWeightFee */}
                            <Col span={4}>
                              <P>ส่วนลดน้ำหนักขาด *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={mutationVariables.lostWeightFee}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    lostWeightFee: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* lateTicketFee */}
                            <Col span={4}>
                              <P>ค่าปรับส่งตั๋วล่าช้า *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={mutationVariables.lateTicketFee}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    lateTicketFee: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* damagedGoodFee */}
                            <Col span={4}>
                              <P>ค่าสินค้าชำรุดเสียหาย *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={mutationVariables.damagedGoodFee}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    damagedGoodFee: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* discountFee */}
                            <Col span={4}>
                              <P>ค่าส่วนลดรับ *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={mutationVariables.discountFee}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    discountFee: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* excessPaymentFee */}
                            <Col span={4}>
                              <P>ค่าส่วนเกิน/ส่วนขาดจากการชำระหนี้ *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={mutationVariables.excessPaymentFee}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    excessPaymentFee: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* accidentFee */}
                            <Col span={4}>
                              <P>ค่าเสียหายจากอุบัติเหตุ *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={mutationVariables.accidentFee}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    accidentFee: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* lostInsuranceFee */}
                            <Col span={4}>
                              <P>เงินจ่ายล่วงหน้า - เงินประกัน *</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                value={mutationVariables.lostInsuranceFee}
                                onChange={(e) => {
                                  setMutationVariables({
                                    ...mutationVariables,
                                    lostInsuranceFee: _.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value),
                                  })
                                }}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='number'
                                step={0.1}
                                min={0}
                              />
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            {/* totalAmount */}
                            <Col span={4}>
                              <P>ยอดสุทธิ</P>
                            </Col>
                            <Col span={6}>
                              <Input width='100%'
                                disabled={true}
                                value={parseFloat(totalPaid).toFixed(2)}
                                onKeyDown={(e) => {
                                  if (!checkFloat(e)) {
                                    e.preventDefault()
                                  }
                                }}
                                type='text'
                                step={0.1}
                                min={0}
                              />
                            </Col>
                          </Div>
                          {/* calculate info */}
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={6}>
                              <Div display='flex' flexDirection='row' justifyContent='space-between'>
                                <P>จำนวนเงิน</P>
                                <P>{parseFloat(mutationVariables.amountReceived || 0).toFixed(2)} บาท</P>
                              </Div>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={6}>
                              <Div display='flex' flexDirection='row' justifyContent='space-between'>
                                <P>หัก ณ ที่จ่าย</P>
                                <P>{parseFloat(mutationVariables.amountWithHeld).toFixed(2)} บาท</P>
                              </Div>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={6}>
                              <Div display='flex' flexDirection='row' justifyContent='space-between' style={{ borderBottom: '0.6px solid #B8B8B8' }}>
                                <P>ส่วนหัก</P>
                                <P>{parseFloat(mutationVariables.pdrBankFees + mutationVariables.lostWeightFee + mutationVariables.damagedGoodFee + mutationVariables.lateTicketFee + mutationVariables.excessPaymentFee + mutationVariables.accidentFee + mutationVariables.lostInsuranceFee + mutationVariables.discountFee).toFixed(2)} บาท</P>
                              </Div>
                            </Col>
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 16px'>
                            <Col span={6}>
                              <Div display='flex' flexDirection='row' justifyContent='space-between' style={{ borderBottom: '0.6px solid #000000' }}>
                                <P bold>ยอดชำระ</P>
                                <P bold>{parseFloat((mutationVariables.amountReceived || 0) + mutationVariables.pdrBankFees + mutationVariables.amountWithHeld + mutationVariables.lostWeightFee + mutationVariables.damagedGoodFee + mutationVariables.lateTicketFee + mutationVariables.excessPaymentFee + mutationVariables.accidentFee + mutationVariables.lostInsuranceFee + mutationVariables.discountFee).toFixed(2)} บาท</P>
                              </Div>
                            </Col>
                            {
                              !(parseFloat((mutationVariables.amountReceived || 0) + mutationVariables.pdrBankFees + mutationVariables.amountWithHeld + mutationVariables.lostWeightFee + mutationVariables.damagedGoodFee + mutationVariables.lateTicketFee + mutationVariables.excessPaymentFee + mutationVariables.accidentFee + mutationVariables.lostInsuranceFee + mutationVariables.discountFee).toFixed(2) === parseFloat(totalPaid).toFixed(2))
                              && <P bold color={color.error} margin='0 0 0 100px'>ยอดชำระไม่ถูกต้อง</P>
                            }
                          </Div>
                          <Div display='flex' flexDirection='row' margin='0 0 0 215px'>
                            <Upload
                              listType="picture-card"
                              customRequest={() => null}
                              processData={false}
                              beforeUpload={() => false}
                              multiple={true}
                              onChange={e => setMutationVariables({
                                ...mutationVariables,
                                paidfiles: e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)),
                              })}
                            >
                              <div>
                                <Icon type="plus" />
                                <div className="ant-upload-text">อัพโหลด</div>
                              </div>
                            </Upload>
                          </Div>
                        </Div>
                      </Wrapper>
                      <PaymentActionBar
                        loading={loading}
                        disabled={
                          _.isUndefined(mutationVariables.paidDate) || _.isUndefined(mutationVariables.bank) || _.isEmpty(mutationVariables.bank) || _.isUndefined(mutationVariables.customerBankFees)
                          || _.isUndefined(mutationVariables.amountReceived)
                          || (method === 'CHEQUE' && _.isUndefined(mutationVariables.chequeNumber))
                          || (method === 'CHEQUE' && _.isUndefined(mutationVariables.chequeDate))
                          || (method === 'TRANSFER' && _.isUndefined(mutationVariables.bankNumber))
                          || !(parseFloat(mutationVariables.amountReceived + mutationVariables.pdrBankFees + mutationVariables.amountWithHeld + mutationVariables.lostWeightFee + mutationVariables.damagedGoodFee + mutationVariables.lateTicketFee + mutationVariables.excessPaymentFee + mutationVariables.accidentFee + mutationVariables.lostInsuranceFee + mutationVariables.discountFee).toFixed(2) === parseFloat(totalPaid).toFixed(2))
                        } // condition here
                        doAction={doAction}
                        mutationVariables={{ ...mutationVariables }}
                        bill={info}
                        grandTotal={totalPaid}
                        type={method}
                      />
                    </Div>
                  )}
                  </Mutation>
                </Div>
              )
            }
        }
        </Query>
      }
    </Div>
  )
}

export default Index
export { Index }
